module.exports = __webpack_public_path__ + "static/media/dana1.ac0c5746.jpg";